/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */
/**
 * <pre><code>Represents different features supported by this system like Downloads, Upload by external users, Updates by
 * external users, Approvals etc.,
 * <\/code><\/pre>
 **/
export var ReportFeature;
(function (ReportFeature) {
    ReportFeature["DOWNLOAD"] = "DOWNLOAD";
})(ReportFeature || (ReportFeature = {}));
